import { RetrieveSignatureSessionResponseBody } from 'bff'
import { useEffect, useState } from 'react'

export const useSignatureSession = ({
  createSession,
  onCreated,
}: {
  createSession: () => Promise<RetrieveSignatureSessionResponseBody>
  onCreated?: (session: RetrieveSignatureSessionResponseBody) => void
}) => {
  const [isLoading, setIsLoading] = useState(true)
  const [session, setSession] = useState<RetrieveSignatureSessionResponseBody>()

  useEffect(() => {
    createSession()
      .then((session) => {
        setSession(session)
        onCreated?.(session)
      })
      .finally(() => setIsLoading(false))
  }, [])

  return {
    isLoading,
    session,
  }
}
